import { IDotThi } from "../../model/respone/tct/IDotThi";
import { apiClient } from "../apiClient";

export const DOT_THI_API = "dot-thi";
export const dotThiApi = {
  SelectAll: () => apiClient.get(`${DOT_THI_API}`),
  SelectByHocKyNamHoc: (hocKy: number, namHoc: string) => apiClient.get(`${DOT_THI_API}?hoc_ky=${hocKy}&nam_hoc=${namHoc}`),
  Insert: (payload: IDotThi) => apiClient.post(`${DOT_THI_API}`, payload),
  Update: (payload: IDotThi) => apiClient.put(`${DOT_THI_API}`, payload),
  Delete: (id: number) => apiClient.delete(`${DOT_THI_API}/${id}`),
};
